import React from 'preact';

export default props => (
  <div className="not-found-404">
    <div className="emoji">
      (╯°□°)╯︵ ┻━┻
      <br />
      <span className="message">Dirty darn! There's nothing here.</span>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./client/components/page/NotFound.jsx